const maintenanceMessages = {
  post: 'Maintenance Added Successfully',
  update: 'Maintenance Updated Successfully',
  delete: 'Maintenance Successfully Deleted',
};

export default maintenanceMessages;